// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import WebsiteContainer from '../views/WebsiteContainer.vue'
import Jackpots from '../views/Jackpots.vue' // Componente para la vista de jackpots

const routes = [
  {
    path: '/',
    name: 'website',
    component: WebsiteContainer
  },
  {
    path: '/jackpots/:adminId/:token',
    name: 'external-jackpots',
    component: Jackpots,
    props: route => ({
      adminId: route.params.adminId,
      token: route.params.token
    })
  }
];
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
